import styled from 'styled-components'

interface ICostSummaryTotalRowStyledProps {}

export const CostSummaryTotalRowStyled = styled.tr<ICostSummaryTotalRowStyledProps>`
  display: contents;

  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  th {
    font-size: ${(props) => props.theme.typography.pxToRem(16)};
    font-weight: ${(props) => props.theme.fontWeights.bold};
    text-align: left;
  }

  td {
    font-weight: ${(props) => props.theme.fontWeights.bold};
    text-align: right;
  }
`
